import { render, staticRenderFns } from "./CardSet.vue?vue&type=template&id=5855b59a&scoped=true&"
import script from "./CardSet.vue?vue&type=script&lang=js&"
export * from "./CardSet.vue?vue&type=script&lang=js&"
import style0 from "./CardSet.vue?vue&type=style&index=0&id=5855b59a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5855b59a",
  null
  
)

export default component.exports